import { render, staticRenderFns } from "./WordsList.vue?vue&type=template&id=20945bf2&scoped=true"
import script from "./WordsList.vue?vue&type=script&lang=js"
export * from "./WordsList.vue?vue&type=script&lang=js"
import style0 from "./WordsList.vue?vue&type=style&index=0&id=20945bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20945bf2",
  null
  
)

export default component.exports